import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { HttpClient } from 'src/Helpers/http/http';
import { url } from 'src/Helpers/utils/Constant';
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Container,
  IconButton,
  Tooltip,
  useTheme,
} from '@mui/material';
import GlobalLoader from 'src/components/SuspenseLoader/GlobalLoader';
import CardMoneyReceipt from '../components/CardMoneyReceipt';
import { useReactToPrint } from 'react-to-print';
import { SimCardDownload } from '@mui/icons-material';
import MoneyReceiptBillingInfo from '../components/MoneyReceiptBillingInfo';
import PrintSingleMoneyReceipt from '../../memberList/singleMember/PrintInformationForm/PrintSingleMoneyReceipt/PrintSingleMoneyReceipt';
import OldMoneyReceiptBillingInfo from '../components/OldMoneyReceiptBillingInfo';

const SingleOldMoneyReceipt = () => {
  const { id } = useParams();
  const [SingleOldMoneyReceipt, setSingleMoneyReceipt] = useState<any>(
    {} as any
  );
  const [loading, setLoading] = useState<Boolean>(false);
  // const [editMode, setEditMode] = useState(false);
  const theme = useTheme();
  const componentRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [showModal, setShowModal] = useState<boolean>(false);
  useEffect(() => {
    setLoading(true);
    (async function () {
      try {
        const res: any = await HttpClient.get(
          `${url}/api/atab/admin/money-receipt/old/${id}`
        );

        if (res.success) {
          setSingleMoneyReceipt(res.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    })();
  }, [id]);

  return (
    <div>
      <Helmet>
        <title>Atab - Single money receipt</title>
      </Helmet>

      <Container sx={{ mt: 5 }} maxWidth='lg'>
        {!loading ? (
          <Box ml={3}>
            {SingleOldMoneyReceipt && (
              <Card className='invoice_print_form'>
                <CardHeader
                  title={`Money Receipt Details`}
                  action={
                    <Tooltip title='Print money receipt'>
                      <IconButton onClick={handlePrint}>
                        <SimCardDownload
                          sx={{
                            cursor: 'pointer',
                            color: theme.colors.primary.main,
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  }
                />
                <CardContent>
                  <OldMoneyReceiptBillingInfo
                    showModal={showModal}
                    setShowModal={setShowModal}
                    singleInvoiceDetails={SingleOldMoneyReceipt}
                  />
                </CardContent>
                <div className='invoice_footer_form'>
                  {SingleOldMoneyReceipt && (
                    <PrintSingleMoneyReceipt
                      singleMoneyReceipt={SingleOldMoneyReceipt}
                      componentRef={componentRef}
                    />
                  )}
                </div>
              </Card>
            )}
          </Box>
        ) : (
          <GlobalLoader />
        )}
      </Container>
    </div>
  );
};

export default SingleOldMoneyReceipt;
